var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKadenaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 24,
    viewBox: "0 0 90 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#27b7e6;}.b{fill:url(#a);}.c{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.015,
    y1: 0.5,
    x2: 0.962,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#054f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#054f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#1174b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#1a91cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#21a6da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#25b2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#27b7e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.07,
    y1: 0.257,
    x2: 0.527,
    y2: 0.57,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#054f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#0b62ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#1581c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#1d98d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#22a9dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#25b3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#27b7e6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27.936 -30.777)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.629 30.777)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M125.8,28.112h2.981v4.344l4.143-4.344h3.537l-4.615,4.813,4.884,7.178h-3.47l-3.47-5.182-1.011,1.057V40.1H125.8Z",
    transform: "translate(-125.797 -28.112)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M151.59,41.994c0-1.9,1.516-2.477,3.3-2.712,1.617-.2,2.19-.371,2.19-.96,0-.556-.354-.927-1.179-.927-.876,0-1.314.388-1.4,1.112h-2.526c.068-1.6,1.3-2.965,3.907-2.965a4.491,4.491,0,0,1,2.8.707,2.856,2.856,0,0,1,1.095,2.459v4.346c0,.691.067,1.078.3,1.23V44.4h-2.661a2.4,2.4,0,0,1-.286-.96H157.1a2.834,2.834,0,0,1-2.56,1.179C152.82,44.621,151.59,43.7,151.59,41.994Zm5.558-.674V40.293a6.635,6.635,0,0,1-1.415.455c-1.061.235-1.5.5-1.5,1.161,0,.691.506.96,1.179.96A1.567,1.567,0,0,0,157.148,41.32Z",
    transform: "translate(-140.596 -32.412)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M173.467,35.81c0-2.684,1.55-4.545,3.773-4.545a2.691,2.691,0,0,1,2.408,1.224h.051V28.112h2.745V40.1h-2.627V38.946h-.033a2.843,2.843,0,0,1-2.543,1.426C175.033,40.372,173.467,38.678,173.467,35.81Zm6.3,0c0-1.442-.59-2.482-1.786-2.482-1.1,0-1.735,1.006-1.735,2.448,0,1.493.64,2.432,1.7,2.432C179.093,38.208,179.767,37.219,179.767,35.81Z",
    transform: "translate(-153.148 -28.112)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M197.109,40.052a4.34,4.34,0,0,1,4.43-4.548,4.241,4.241,0,0,1,2.947,1.078A5.487,5.487,0,0,1,206,40.776h-6.2a1.9,1.9,0,0,0,1.937,1.886,1.432,1.432,0,0,0,1.432-.859h2.678a3.513,3.513,0,0,1-1.448,2.038,4.564,4.564,0,0,1-2.7.792A4.362,4.362,0,0,1,197.109,40.052Zm6.114-.91a1.667,1.667,0,0,0-1.634-1.684c-1.044,0-1.583.657-1.768,1.684Z",
    transform: "translate(-166.713 -32.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M220.617,35.757h2.644v1.179h.051a3.024,3.024,0,0,1,2.661-1.431,2.942,2.942,0,0,1,3,3.267V44.38h-2.746V39.327c0-.909-.455-1.532-1.347-1.532a1.61,1.61,0,0,0-1.516,1.819V44.38h-2.745Z",
    transform: "translate(-180.199 -32.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M242.669,41.994c0-1.9,1.516-2.477,3.3-2.712,1.617-.2,2.189-.371,2.189-.96,0-.556-.353-.927-1.179-.927-.876,0-1.314.388-1.4,1.112h-2.526c.067-1.6,1.3-2.965,3.907-2.965a4.491,4.491,0,0,1,2.8.707,2.857,2.857,0,0,1,1.095,2.459v4.346c0,.691.067,1.078.3,1.23V44.4H248.5a2.408,2.408,0,0,1-.287-.96h-.033a2.835,2.835,0,0,1-2.56,1.179C243.9,44.621,242.669,43.7,242.669,41.994Zm5.558-.674V40.293a6.635,6.635,0,0,1-1.415.455c-1.061.235-1.5.5-1.5,1.161,0,.691.505.96,1.179.96A1.567,1.567,0,0,0,248.227,41.32Z",
    transform: "translate(-192.851 -32.412)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.936 30.777)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M61.808,28.112H54.751l-8.305,8.715v7.26Z",
    transform: "translate(-40.48 -28.112)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5.965,
    height: 24,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M67.638,76.271l-9.8-14.424L53.844,66l6.867,10.274Z",
    transform: "translate(-45.77 -52.271)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKadenaLogo);
export default __webpack_public_path__ + "static/media/kadena-logo.89abe6e7d62069fbd55fb680ba443e02.svg";
export { ForwardRef as ReactComponent };